import styled from '@emotion/styled'

export const Resources = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

export const LayerContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  &.groundwater {
    width: 100%;
    height: 100%;
  }
`
